import React from 'react';
import { RawButton } from '@common-fe/common-fe';
import styled from 'styled-components';

const StyledButton = styled(RawButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: ${({ theme }) => theme.rounds.button1Round};
  border: 2px solid ${({ theme }) => theme.colors.buttonPrimary};
  background: ${({ theme }) => theme.colors.canvas};
  transition: all 0.2s;

  &:hover:not(:disabled) {
    cursor: pointer;
    background: ${({ theme }) => theme.colors.buttonSecondaryHover};
  }

  &:disabled {
    cursor: not-allowed;
    border-color: ${({ theme }) => theme.colors.buttonSecondaryDisabledBorder};
    background: ${({ theme }) => theme.colors.buttonSecondaryDisabled};
  }
`;

interface Props {
  icon: React.ReactNode;
  onClick: () => void;
  title: string;
  testId: string;
  disabled?: boolean;
}

const TopbarIconButton: React.FC<Props> = ({ icon, onClick, title, testId, disabled }) => (
  <StyledButton
    onClick={onClick}
    disabled={disabled}
    title={title}
    data-testid={`${testId}_button`}
  >
    {icon}
  </StyledButton>
);

export default TopbarIconButton;
